import React from "react";
import { useToast } from "@sainsburys-tech/fable";

export const ToastConsumer = ({ children }) => children(useToast());

export const withToastManager = Comp => props => (
  <ToastConsumer>
    {toastManager => <Comp toastManager={toastManager} {...props} />}
  </ToastConsumer>
);
